import { groupBy } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { ACCESS_SELECTORS, MarketerProduct } from '../../typings/marketers';
import { TextCell } from '../TextCell/TextCell';

import './MarketerProductCell.css';

const BLOCK = 'marketer-products-cell';

export interface MarketerProductsCellProps {
    products: MarketerProduct[];
    places: Map<number, string>;
}

export const MarketerProductsCell = React.memo(function(props: MarketerProductsCellProps) {
    const { products, places } = props;

    const getAccessText = (access: string): string => {
        return (ACCESS_SELECTORS.find(item => item.val === access) || { text: '' }).text;
    };

    const getProductInfo = ({ placeIds, productName }: MarketerProduct): string =>
        placeIds.length > 0 ? `${productName} (${placeIds.join(', ')})` : productName;

    const getProductTitleInfo = ({ placeIds, productName }: MarketerProduct): string =>
        `- ${`${productName} \n${placeIds
            .map(id => (places.has(id) ? `${id} - ${places.get(id)}` : ''))
            .join('\n')}`}`.trim();

    const groupedByAccess = groupBy(products, 'access');
    const title = Object.keys(groupedByAccess)
        .sort()
        .reduce<string[]>(
            (acc, access) => [
                ...acc,
                `${getAccessText(access)}:\n${groupedByAccess[access].map(getProductTitleInfo).join('\n')}\n`
            ],
            []
        );

    return (
        <div className={Bem.cls(BLOCK)} title={title.join('\n').trim()}>
            {Object.keys(groupedByAccess)
                .sort()
                .reduce<JSX.Element[]>(
                    (acc, access, index) => [
                        ...acc,
                        <TextCell cls={Bem.cls(BLOCK, 'text')} key={`${BLOCK}-${index}`}>
                            {getAccessText(access)}: {groupedByAccess[access].map(getProductInfo).join(', ')}
                        </TextCell>
                    ],
                    []
                )}
        </div>
    );
});
